export const E: number = 0;
export const SC: number = 1;
export const W: number = 2;
export const H1: number = 3;
export const H2: number = 4;
export const H3: number = 5;
export const H4: number = 6;
export const H5: number = 7;
export const L1: number = 8;
export const L2: number = 9;
export const L3: number = 10;
export const L4: number = 11;
export const BA: number = 12;
export const BB: number = 13;
export const BC: number = 14;
export const MIMIC_CHEST: number = 15; // mimic
export const CHEST_WILD: number = 16;
export const CHEST_EXPLODE: number = 17;
export const CHEST_RESPIN: number = 18;
export const KEY: number = 19;
export const LAST_SYMBOL: number = 20;

export class ServerSymbols {
	public static isWild(symbol: number): boolean {
		return symbol === W;
	}

	public static isOrdinarySymbol(symbol: number): boolean {
		return symbol === H1
			|| symbol === H2
			|| symbol === H3
			|| symbol === H4
			|| symbol === H5
			|| symbol === L1
			|| symbol === L2
			|| symbol === L3
			|| symbol === L4;
	}

	public static isScatter(symbol: number): boolean {
		return symbol === SC;
	}

	public static getWilds(): number[] {
		return [W];
	}

	public static isChest(symbol: number): boolean {
		return symbol === CHEST_WILD || symbol === CHEST_EXPLODE || symbol === CHEST_RESPIN;
	}
}


// WEBPACK FOOTER //
// ./@fantasmagames/prototype/src/symbols/ServerSymbols.ts